import { Download } from "lucide-react";
import { useNotify, usePermissions, useTranslate } from "ra-core";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useReportsClient } from "../ReportsClientContext";
import { ReportError, type ExportTable, type ReportFilters } from "../types";
import { csvFileName, downloadCsv, rowsToCsv } from "./csvExport";

/** Admin-only (spec 09 §3.3, §5). The RPC re-checks the role and writes audit_log 'export.report'. */
export const ExportCsvButton = ({
  table,
  from,
  to,
  filters,
}: {
  table: ExportTable;
  from: string;
  to: string;
  filters: ReportFilters;
}) => {
  const translate = useTranslate();
  const notify = useNotify();
  const client = useReportsClient();
  const { permissions } = usePermissions();
  const [busy, setBusy] = useState(false);
  if (permissions !== "admin") return null;
  const onClick = async () => {
    setBusy(true);
    try {
      const rows = await client.exportRows(table, from, to, filters);
      downloadCsv(csvFileName(table, from, to), rowsToCsv(rows));
      notify("gavion.export.done", {
        type: "success",
        messageArgs: { smart_count: rows.length },
      });
    } catch (e) {
      notify(
        e instanceof ReportError && e.code === "forbidden"
          ? "gavion.export.forbidden"
          : "gavion.export.failed",
        { type: "error" },
      );
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button variant="outline" size="sm" onClick={onClick} disabled={busy}>
      <Download className="size-4" aria-hidden="true" />
      {translate("gavion.export.csv")}
    </Button>
  );
};
